import { render, staticRenderFns } from "./DeviceRejectedList.vue?vue&type=template&id=09ef929d&scoped=true&"
import script from "./DeviceRejectedList.vue?vue&type=script&lang=js&"
export * from "./DeviceRejectedList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRejectedList.vue?vue&type=style&index=0&id=09ef929d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef929d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VDataTable})
